export default __webpack_public_path__ + "static/media/img-02.c5d8f579.png";